import PropTypes from 'prop-types'
import EmployeeForm from "../EmployeeForm";
import EmployeeProfile from "../EmployeeProfile";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/common/components/ui/dialog'

function EmployeeFormDialog({ employee, show, onClose, onSubmit, onUpdate }) {
  const isNewEmployee = employee == null

  return (
    <Dialog open={show} onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{isNewEmployee ? 'Create Employee' : 'Edit Employee'}</DialogTitle>
        </DialogHeader>
        {isNewEmployee
          ? <EmployeeForm submitLabel="Create" onCancel={onClose} onSubmit={onSubmit} />
          : <EmployeeProfile show={true} employee={employee} onUpdateClick={onUpdate} />
        }
      </DialogContent>
    </Dialog>
  )
}

EmployeeFormDialog.propTypes = {
  employee: PropTypes.object,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
}

export default EmployeeFormDialog
